<template>
  <div class="prescriptionlist">
    <div class="personal">
      <p>患者：{{ listData.name }}</p>
      <p>
        性别：
        <span v-if="listData.sex == 0">女</span>
        <span v-else>男</span>
      </p>
      <p>年龄：{{ listData.age }}岁</p>
    </div>
    <div class="content">
      <p class="head_title">诊断</p>
      <p class="content_details">{{ listData.diseases ? listData.diseases : '' }}{{
          listData.diseases && listData.symptons ? '·' : ''
        }}{{ listData.symptons }}</p>
    </div>
    <div class="content">
      <p class="head_title">
        <span>{{ listData.prescription ? listData.prescription.prescription_type_str : '' }}</span>
        {{ listData.prescription ? listData.prescription.name : '' }}（共{{
          listData.prescription ? listData.prescription.content.length : ''
        }}味药）
      </p>

      <p
        class="content_details2"
        v-if="listData.prescription?listData.prescription.show_type == 1&& !is_Doctor:'0' "
      >
        <span
          class="medicament_li"
          v-for="(item, index) in listData.prescription?listData.prescription.content:[]"
          :key="index"
        >{{ item.name }}&nbsp;{{ item.count }}{{
            item.unit ? item.unit : 'g'
          }}{{ item.usage ? '(' + item.usage + ')' : '' }}</span
        >
      </p>
      <p
        class="content_details2"
        v-else-if="is_Doctor"
      >
        <span
          class="medicament_li"
          v-for="(item, index) in listData.prescription?listData.prescription.content:[]"
          :key="index"
        >{{ item.name }}&nbsp;{{ item.count }}{{
            item.unit ? item.unit : 'g'
          }}{{ item.usage ? '(' + item.usage + ')' : '' }}</span
        >
      </p>
      <p
        v-else-if="listData.prescription?listData.prescription.show_type == 2 && !is_Doctor:false"
        class="medicament_li_tips1 medicament_li_tips2"
      >
        购买后即可查看完整药方
      </p>
      <p
        class="content_details2"
        v-else-if="listData.prescription?listData.prescription.show_type ==3&& !is_Doctor:false"
      >
        <span
          class="medicament_li"
          v-for="(item, index) in listData.prescription?listData.prescription.content:[]"
          :key="index"
        >{{ item.name }}&nbsp;</span
        >
      </p>
      <p
        v-if="listData.prescription?listData.prescription.show_type == 3&& !is_Doctor:false "
        class="medicament_li_tips1"
      >
        购买后即可查看完整药方
      </p>
      <p class="posts_number" v-if="listData.prescription?listData.prescription.text_show_type != 3:false">
        帖数：共{{ listData.prescription ? listData.prescription.total_count : '0' }}帖
      </p>
    </div>
    <div class="content">
      <p class="head_title">用法 </p>
      <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type == 1:''">
        内服;共{{ listData.prescription ? listData.prescription.total_count : '' }}帖,每日{{ listData.prescription ? listData.prescription.one_day_count : '' }}帖,每帖分{{ listData.prescription ? listData.prescription.once : '' }}次服用
      </p>
      <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type == 2:''">
        外用;共{{ listData.prescription ? listData.prescription.total_count : '' }}帖,每日{{ listData.prescription ? listData.prescription.one_day_count : '' }}帖,每帖分{{ listData.prescription ? listData.prescription.once : '' }}次使用
      </p>
      <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type == 3:''">
        每日{{ listData.prescription ? listData.prescription.one_day_count : '' }}次,每次{{ listData.prescription ? listData.prescription.once : '' }}g,预计可用{{ listData.prescription ? listData.prescription.use_days : '' }}天
      </p>
    </div>
    <div class="content">
      <p class="head_title">
        医嘱
        <span class="ask" v-show="is_app && is_Patient" @click="askdoctor"
        >咨询医生</span>
      </p>
      <p class="content_details">{{ listData.prescription ? listData.prescription.advice : '' }}</p>
    </div>
    <div class="content" v-show="is_Doctor">
      <p class="head_title">
        费用
      </p>
      <p class="content_details">药费:￥{{
          listData.prescription ? (Number(listData.prescription.drug_price) * Number(listData.prescription.total_count)).toFixed(2) : ''
        }}</p>
      <p class="content_details">诊金:￥{{ listData.prescription ? listData.prescription.diagnosis_price : '' }}</p>
      <p class="content_details">治疗服务费:￥{{ listData.prescription ? listData.prescription.service_price : '' }}</p>
    </div>
    <div class="content" v-show="is_Doctor">
      <p class="head_title">
        医生心得
      </p>
      <p class="content_details">{{ listData.experience ? listData.experience : '无' }}</p>
    </div>
    <div class="content">
      <p class="dorctor_name">医生：{{ listData.prescription ? listData.prescription.doctor_name : '' }}</p>
      <p class="dorctor_time">开方时间：{{ listData.created_at ? distance(listData.created_at) : '' }}</p>
    </div>
    <button
      class="buynow"
      @click="order"
      v-if="(is_Patient || !is_app) && listData.order_status == 0 && listData.is_expired != 1"
    >
      立即购药
    </button>
    <Loading :value="show"/>
    <van-popup
      class="express_content"
      v-model="show_phone"
      position="center"
      round
      :style="{ height: '16.44rem',width:'18.13rem' }"
    >
      <div class="top_box">
        <p class="tip_title1">请绑定手机号!</p>
        <div class="tip_info">
          <input type="text" v-model="phones" maxlength="11">
        </div>
        <div class="botton">
          <button class="ok" @click="phoneOk">确认绑定</button>
          <p class="cancel" @click="phoneCancel">取消</p>
        </div>
      </div>

    </van-popup>
  </div>
</template>
<script>
import {deviceType} from '../../util/deviceType'
import http from '../../util/gaeaApiConfig'
import http2 from '../../util/hermerApiConfig'
import http3 from '../../util/iapetusApiConfig'
import Loading from '../loading/loading'
import VConsole from 'vconsole'
import Keyboard from '../prescription/keyboard'
import weixuanze from '../../assets/images/doctor/weixuanze.png'
import xuanze from '../../assets/images/doctor/check.png'
import wx from 'weixin-jsapi'

export default {
  components: {
    Loading
  },
  data () {
    return {
      listData2: {},
      show: true,
      listData: {
        name: '',
        sex: 1,
        age: 28,
        diagnosis: '',
        medicament: [],
        Posts: 10,
        usage: '',
        medicaladvice: '',
        doctor: '',
        createdtime: ''
      },
      isshowarea: false,
      isshowphone: false,
      disabled: true,
      time: 0,
      btntxt: '获取验证码',
      area_code: '',
      area_codeArr: {},
      phone: '',
      verification: '',
      is_app: deviceType.isApp,
      is_Patient: deviceType.isPatient,
      is_Doctor: deviceType.isDoctor,
      diagnosis_prescription_id: '',
      prescription_id: 1,
      platform_type: '1',
      user_id: 1720,
      doctor_id: '',
      token: '',
      isApp: '',
      doctor_user_id: '',
      is_mini: false,
      show_title: false,
      show_phone: false,
      phones: '',
      checked: false,
      activeIcon: xuanze,
      inactiveIcon: weixuanze,
      isWxLogin: false,
      is_weixin: deviceType.isWeiXin,
      unionid: '',
      openid: '',
      ttt: false,
      appid: 'wxaad7ad4759a50bb1',
    }
  },
  mounted () {
    this.isApp = this.$appUtils.isApp()
    if (this.isApp == 'IOS') {
      let bridge = window.WebViewJavascriptBridge
      bridge.callHandler('getUserInfo', '', response => {
        this.user_id = response.user_id
        this.token = response.token
        this.platform_type = response.platform_type
      })
    }
    else if (this.isApp == 'android') {
      let user_info = this.$appUtils.appData()
      if (user_info) {
        this.user_id = user_info.user_id
        this.token = user_info.token
        this.platform_type = user_info.platform_type
      }
    }
    else if (this.$route.query.is_mini) {
      this.token = this.$route.query.token
      this.user_id = this.$route.query.user_id
      this.doctor_user_id = this.$route.query.doctor_user_id
      this.is_mini = true
      this.platform_type = '1'
    }
    else if (this.$route.query.is_baoan) {
      this.token = this.$route.query.token
      this.user_id = this.$route.query.user_id
      this.doctor_user_id = this.$route.query.doctor_user_id
      this.is_mini = true
      this.platform_type = '1'
    }
    else {
      this.show_title = true
      this.user_id = localStorage.getItem('user_id')
      this.token = localStorage.getItem('token')
      this.platform_type = '1'
    }
    let doctor_id = this.$route.query.doctor_id
    if (doctor_id) {
      this.doctor_id = doctor_id
    }
    if (this.$route.query.diagnosis_prescription_id) {
      this.diagnosis_prescription_id = this.$route.query.diagnosis_prescription_id
    } else {
      this.diagnosis_prescription_id = this.$route.query.id
    }
    if(this.is_weixin &&!this.is_mini){
      // if (this.diagnosis_prescription_id) {
      //   http3.get('feature/diagnosis/prescriptions/'+this.diagnosis_prescription_id).then(res=>{
      //     if(res.data.status_code == 200){
      //       if(res.data.data.is_show == 1){
      //         this.ttt = true
      //         new VConsole()
      //       }
      //     }
      //   })
      // }
      if(this.diagnosis_prescription_id == 363){
        new VConsole()
      }

      if(!this.$route.query.Confirmtype){
        this.$router.push({
          path: '/order_confirm',
          query: {
            diagnosis_prescription_id:this.diagnosis_prescription_id
          }
        })
      }
    }

    setTimeout(() => {
      this.getinit()
    }, 1000)
  },
  methods: {
    askdoctor () {
      let bridge = window.WebViewJavascriptBridge
      this.isApp = this.$appUtils.isApp()
      if (this.isApp == 'IOS') {
        bridge.callHandler('closeWebView', '', response => {
        })
      } else if (this.isApp == 'android') {
        this.$appUtils.appCloseWebView()
      }
    },
    openagreement () {
      let that = this
      let params = {
        type: 1
      }
      http2.get('/protocol', {params}).then(function (res) {
        if (res.data.status_code == 200) {
          window.location.href = res.data.data.url
        }
      })
    },
    distance (day) {
      // 过去的时间戳
      var now = new Date(day * 1000) // 过去 //年
      var year = now.getFullYear() // 月
      var month = now.getMonth() + 1 // 日
      var date = now.getDate() // 时
      var hour = now.getHours() // 分
      var minute = now.getMinutes() // 秒
      var second = now.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      if (hour < 10) {
        hour = '0' + hour
      }
      if (minute < 10) {
        minute = '0' + minute
      }
      if (second < 10) {
        second = '0' + second
      }
      var timer =
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second

      return timer
    },
    order () {
      this.$router.push({
        path: '/order',
        query: {
          diagnosis_prescription_id: this.diagnosis_prescription_id,
          prescription_id: this.prescription_id,
          token: this.token,
          user_id: this.user_id,
          doctor_user_id: this.doctor_user_id,
          is_mini: this.is_mini,
          openid: this.openid,
        }
      })
    },
    getinit () {
      let url = ''
      if (deviceType.isDoctor) {
        url =
          'studio/doctors/' +
          this.doctor_id +
          '/diagnosis_prescriptions/' +
          this.diagnosis_prescription_id +
          '?platform_type=' +
          this.platform_type
      } else {
        url =
          '/diagnosis_prescriptions/' +
          this.diagnosis_prescription_id +
          '?platform_type=' +
          this.platform_type
      }

      http3
        .get(url, {
          headers: {
            Authorization: this.token
          }
        })
        .then((res) => {
          if (res.data.status_code == 200) {
            this.listData = res.data.data
            this.prescription_id = this.listData.prescription.prescription_id
            this.listData.prescription.content = JSON.parse(
              this.listData.prescription.content
            )
            this.show = false
          } else {
            if (this.is_weixin) {
              if(!this.$route.query.Confirmtype){
                this.$router.push({
                  path: '/order_confirm',
                  query: {
                    diagnosis_prescription_id:this.diagnosis_prescription_id
                  }
                })
              }else {
                if (this.diagnosis_prescription_id != '') {
                  // http3.get('feature/diagnosis/prescriptions/' + this.diagnosis_prescription_id).then(res => {
                  //   if (res.data.status_code == 200) {
                      if (!this.openid) {
                        let code = this.$route.query.code
                        if (code) {
                          this.getOpenid(code)
                        } else {
                          let redirectUrl = window.location.href + '&type=true'
                          redirectUrl = encodeURIComponent(redirectUrl)
                          let url =
                            'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                            this.appid +
                            '&redirect_uri=' +
                            redirectUrl +
                            '&response_type=code&scope=snsapi_userinfo&state=type%wechat_redirect'
                          window.location.href = url
                        }
                      }

                  //   } else {
                  //     this.$router.push({
                  //       path: '/order_confirm',
                  //       query: {
                  //         diagnosis_prescription_id: this.diagnosis_prescription_id
                  //       }
                  //     })
                  //   }
                  // })
                }
              }

            } else {
              this.$router.push({
                path: '/order_confirm',
                query: {
                  diagnosis_prescription_id:this.diagnosis_prescription_id
                }
              })
            }
            this.show = false
          }
        })
    },
    getOpenid (code) {
      let params = {code: code, platform_type: 1, wx_type: 1}
      http.get('/users/oauth/user', {params: params}).then( (res)=> {
        console.log(res)
        if (res.data.status_code == 200) {
          this.openid = res.data.data.openid
          this.unionid = res.data.data.unionid
          localStorage.setItem('openid', this.openid)
          let params1 = {
            udid: 'h5',
            openid: res.data.data.openid,
            unionid: res.data.data.unionid,
            nickname: res.data.data.nickname,
            avatar: res.data.data.headimgurl,
            login_type: 'wx',
            platform_type: '4',
          }
          http.post('users/author_login', params1).then(res => {
            if (res.data.msg == '未绑定手机号') {
              this.$router.push({
                path: '/bindPhone',
                query: {
                  unionid: this.unionid,
                  openid: this.openid,
                  udid: 'h5',
                  type: 'wx',
                  area_code: '86',
                  terminal: 'h5',
                  need_verify: '1',
                  platform_type: '1',
                  diagnosis_prescription_id:this.diagnosis_prescription_id
                }
              })
            } else {
              localStorage.setItem('user_id', res.data.data.user_id)
              localStorage.setItem(
                'refresh_token',
                res.data.data.refresh_token
              )
              localStorage.setItem(
                'token',
                res.data.data.access_token
              )

              if (location.href.indexOf("*") == -1) {
                //在当前页面地址加入"#"，使下次不再进入此判断
                location.href = location.href + "*";
                location.reload();
              }
            }
          })
        }
      })
    },
    changearea (item) {
      this.area_code = item.code
      this.isshowarea = false
    },
    getcode () {
      let that = this
      http2.get('/area_codes').then(function (res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.area_codeArr = res.data.data
          that.area_code = res.data.data[0].code
        }
      })
    },
    sendcode () {
      var reg = 11 && /^1\d{10}$/
      let that = this
      if (this.phone == '') {
        alert('请输入手机号码')
      } else if (!reg.test(this.phone)) {
        alert('手机格式不正确')
      } else {
        this.time = 60
        let params = {
          phone: that.phone,
          area_code: that.area_code.toString(),
          type: 'login',
          platform: 'h5',
        }
        http.post('sms_code', params).then(function (res2) {
          // console.log(res2);
          if (res2.data.status_code === 4001) {
          } else if (res2.data.status_code == 200) {
            that.timer()
            that.disabled = true
          }
        })
      }
    },
    checkCancel () {
      window.open('https://dl.zyzk.jiankanghao.net?isTrue=1', '_blank')
    },
    phoneOk () {
      let data = {
        unionid: this.unionid,
        openid: this.openid,
        phone: this.phones,
        udid: 'h5',
        type: 'wx',
        area_code: '86',
        terminal: 'h5',
        need_verify: '0',
        platform_type: '1',
      }
      http.post('users/bind', data).then(res => {
        if (res.data.status_code != 200) {
          this.show_phone = false
          alert(res.data.msg)
        } else {
          localStorage.setItem("user_id", res.data.data.user_id);
          localStorage.setItem(
            "refresh_token",
            res.data.data.refresh_token
          );
          localStorage.setItem(
            "token",
            res.data.data.access_token
          );

          if (location.href.indexOf("#") == -1) {
            //在当前页面地址加入"#"，使下次不再进入此判断
            location.href = location.href + "#";
            location.reload();
          }
          this.show_phone = false
        }
      })
    },
    phoneCancel () {
      this.show_phone = false
    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = '重新获取(' + this.time + ')'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    submit () {
      var that = this
      if (this.verification && this.phone) {
        var params = {
          phone: this.phone,
          area_code: this.area_code.toString(),
          verification_code: this.verification
        }
        // console.log(params)
        http.post('sms_code/verify', params).then(function (res) {
          console.log(res)
          if (res.data.status_code == 200) {
            let data = {
              phone: that.phone,
              area_code: that.area_code.toString(),
              udid: localStorage.getItem('udid'),
              terminal: 'h5',
              platform_type: 1
            }
            let url = 'users/login'
            http.post(url, data).then(function (res2) {
              if (res2.data.status_code == 200) {
                that.isshowphone = false
                localStorage.setItem('user_id', res2.data.data.user_id)
                localStorage.setItem(
                  'refresh_token',
                  res2.data.data.refresh_token
                )
                localStorage.setItem(
                  'access_token',
                  res2.data.data.access_token
                )
                that.$router.push({
                  path: '/order',
                  query: {
                    id: 1
                  }
                })
              } else {
              }
            })
          }
        })
        // that.isshowphone = false;
        // that.isshowsuccess = true;
      } else if (!this.phone) {
        alert('手机号不能为空')
      } else if (!this.verification) {
        alert('验证码不能为空')
      }
    },
    yonghu(type){
      // 查看协议
      http2.get('/protocol?type='+type).then(res=>{
        window.open(res.data.data.url)
      })



    },
  },
  watch: {
    phone (val) {
      if (val.length == 11) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.prescriptionlist {
  width: 100%;
  padding-bottom: 80px;
  box-sizing: border-box;
  padding-top: 5px;

  & > div {
    margin: 0 auto;
    margin-bottom: 5px;
    padding: 0px 10px;
    box-sizing: border-box;
    font-family: PingFang-SC-Medium, PingFang-SC;
    color: #333;

    .head_title {
      line-height: 44px;

      .ask {
        margin-top: 10px;
        float: right;
        padding: 4px 8px;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #ac4b38;
        line-height: 17px;

        &::before {
          content: "";
          display: inline-block;
          width: 15px;
          height: 15px;
          background: url("../../assets/images/order/msg.png") no-repeat center center;
          background-size: cover;
          vertical-align: text-top;
          margin-right: 5px;
        }
      }
    }
  }

  .personal {
    width: calc(100% - 30px);
    height: 44px;
    color: #fff;
    background: linear-gradient(90deg, #ce4d33 0%, #e0684f 100%);
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 8px;
    display: flex;
    line-height: 44px;
    justify-content: space-between;
  }

  .content {
    width: calc(100% - 30px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    border: 1px solid transparent;

    .head_title {
      width: 100%;
      height: 30px;
      line-height: 44px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      // border-bottom: 1px solid #e4e4e4;
      position: relative;

      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 16px;
        background: #de654c;
        position: absolute;
        top: 14px;
        left: -10px;
      }
    }

    .content_details,
    .posts_number {
      font-size: 14px;
      line-height: 30px;
    }

    .content_details2 {
      font-size: 14px;
      line-height: 25px;

      .medicament_li {
        display: inline-block;
        margin-right: 6px;
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
      }
    }

    .medicament_li_tips1 {
      font-size: 12px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #999999;
      line-height: 25px;
      text-align: center;
    }

    .medicament_li_tips2 {
      padding: 20px 0px;
    }

    .posts_number {
      border-top: 1px solid #fef2f0;
    }

    .dorctor_name {
      margin-top: 10px;
      font-size: 14px;
    }

    .dorctor_time {
      font-size: 12px;
      margin-bottom: 10px;
      color: #999999;
    }
  }

  .buynow {
    width: calc(100% - 40px);
    height: 48px;
    background: rgba(172, 75, 56, 1);
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    border: none;
    position: fixed;
    bottom: 10px;
    left: 20px;
  }

  .phone_content {
    height: 344px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: calc(100% - 75px);
    background: #fff;
    border-radius: 10px;
    // border: 1px solid transparent;
    padding: 0;

    .phone_title {
      padding: 17px 0px;
      text-align: center;
      color: #fff;
      background: url("../../assets/images/order/login_head.png") no-repeat center center;
      background-size: cover;
      flex-shrink: 14px;
    }

    .area_code {
      background: #eeeeee;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      padding: 0px 5px;
      font-size: 14px;

      &::after {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("../../assets/images/order/down.png") no-repeat center center;
        background-size: cover;
        vertical-align: middle;
        margin-left: 3px;
      }
    }

    .inputbox {
      width: 90%;
      height: 60px;
      margin: 0 auto;
      /*border: 1px solid red;*/
      border-bottom: 1px solid #cccccc;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      // margin-top: 0.4rem;
      /*padding: 0.4rem 0rem;*/
      /*display: flex;*/
      /*justify-content: space-around;*/
    }

    .inputphone,
    .inputtest {
      height: 60px;
      border: none;
      /*border: 1px solid red;*/
      // text-indent: 0.5rem;
      font-size: 1rem;
      outline: none;
      -webkit-appearance: none;
    }

    .inputphone {
      width: 73%;
    }

    .inputtest {
      width: 60%;
    }

    .timebtns {
      width: 33%;
      height: 32px;
      background: #ac4b38;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 1rem;
      box-sizing: border-box;
      outline: none;
      font-size: 12px;
    }

    .btn_disabled {
      background: #999;
    }

    .phone_submit {
      width: 200px;
      height: 43px;
      line-height: 43px;
      border-radius: 4px;
      background: #ac4b38;
      text-align: center;
      color: #fff;
      font-size: 17px;
      margin: 0 auto;
      margin-top: 20px;
    }

    .submit_tips {
      font-size: 12px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #999999;
      text-align: right;
      margin-top: 10px;
      padding-right: 10px;
    }

    .submit_tips2 {
      font-size: 12px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #999999;
      text-align: center;
      margin-top: 8px;

      span {
        color: #ac4b38;
        text-decoration: underline;
      }
    }
  }

  .success_content {
    height: 240px;
    text-align: center;

    .success_img {
      width: 80px;
      height: 80px;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
    }

    .success_text {
      margin-top: 20px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      font-size: 18px;
    }

    .success_push {
      color: #ac4838;
      margin-top: 12px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
    }
  }
  .express_content {
    display: flex;
    flex-direction: column;

    .top_box {
      flex: 1;

      .tip_img {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.16rem;

        img {
          width: 3rem;
          height: 3rem;
        }
      }

      .tip_title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.25rem;
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .tip_title1 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.25rem;
        font-size: 1.25rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .tip_info {
        width: 100%;
        height: 5.38rem;
        margin-top: 0.81rem;
        display: flex;
        justify-content: center;
        align-items: center;

        dl {
          width: 15.63rem;
          height: 5.38rem;
          background: url("../../assets/images/doctor/box2.png") no-repeat;
          background-size: 100% 100%;
          padding: .75rem;
          box-sizing: border-box;

          dt {
            img {
              width: 2rem;
              height: 2rem;
              border-radius: 50%;
            }
          }

          dd {
            margin-top: .63rem;
            font-size: 0.88rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }

      .xieyi {
        display: flex;
        justify-content: center;
        font-size: 0.75rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        padding: .75rem;
        box-sizing: border-box;

        .van-checkbox {
          margin-right: .2rem;
          width: 1.2rem;
          height: 1.2rem;

          img {
            width: 1.2rem;
            height: 1.2rem;
          }
        }
      }

      .botton {
        margin-top: 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ok {
          width: 15.63rem;
          height: 2.5rem;
          background: #AC4B38;
          border-radius: 0.25rem;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }

        .cancel {
          margin-top: .81rem;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #AC4B38;
        }
      }
    }

    .bot_box {
      width: 100%;
      height: 8%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/prescriptionlist.vue